import React from "react";
import type { State } from "./types";
import { Dispatch, SetStateAction } from "react";
import { cn } from "../../../utils/cn";
import Empty from "./Empty";
import Item from "./Item";

interface Props {
    state: State;
    setState: Dispatch<SetStateAction<State>>;
}

const Component = ({ state, setState }: Props) => {
    // Cambiamos el estilo de la lista dependiendo de la vista
    const viewStyle = state.viewStyle;
    let className = styles.threeColumns;

    if (viewStyle === "twoColumns") {
        className = styles.twoColumns;
    }

    // Si no hay productos y no estamos cargando, mostramos un mensaje
    if (!state.loading && state.items.length === 0) {
        return (
            <Empty
                title="No hay productos disponibles"
                subtitle="Intenta cambiando los filtros de búsqueda. Si necesitas ayuda, no dudes en contactarnos."
            />
        );
    }

    return (
        <div className={cn(className)}>
            {state.items.map(item => (
                <Item state={state} setState={setState} item={item} key={item.id} />
            ))}
        </div>
    );
};

const styles = {
    twoColumns: "grid grid-cols-1 md:grid-cols-2 gap-10 items-stretch",
    threeColumns: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 items-stretch",
};

export default Component;
